import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { specraFocusRing } from './focus-ring';
/** Lightweight native select for dense operational forms and toolbars. */ export const SpecraSelect = /*#__PURE__*/ React.forwardRef(({ className, invalid = false, size = 'default', ...props }, ref)=>/*#__PURE__*/ _jsx("select", {
        "aria-invalid": invalid || undefined,
        className: cn('w-full rounded-[var(--radius-control)] border border-input bg-card px-[var(--space-2-5)] text-[length:var(--fs-ui-caption)] text-foreground disabled:cursor-not-allowed disabled:opacity-50', size === 'sm' ? 'h-[var(--control-height-sm)]' : 'h-[var(--control-height-md)]', specraFocusRing, invalid && 'border-danger', className),
        ref: ref,
        ...props
    }));
SpecraSelect.displayName = 'SpecraSelect';
